import { render } from "./relative-time.vue.js?vue&type=template&id=ca5ec7b2!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./relative-time.vue?vue&type=template&id=ca5ec7b2"
import script from "./relative-time.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./relative-time.vue?vue&type=script&lang=js"
export * from "./relative-time.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./relative-time.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__